import { useEffect } from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import NotificationService from '../services/NotificationService';

export const useNotificationAutomation = () => {
  const { addNotification } = useNotifications();

  useEffect(() => {
    // Initialize the notification service
    const notificationService = NotificationService.getInstance();
    notificationService.initialize(addNotification);

    // Disable all demo/automated notifications
    // notificationService.scheduleRecurringNotifications();
    // const simulateNotifications = () => { ... };
    // simulateNotifications();
  }, [addNotification]);

  return {
    triggerRentReminder: (reminder: any) => {
      NotificationService.getInstance().sendRentReminder(reminder);
    },
    triggerMaintenanceUpdate: (update: any) => {
      NotificationService.getInstance().sendMaintenanceUpdate(update);
    },
    triggerApplicationUpdate: (update: any) => {
      NotificationService.getInstance().sendApplicationUpdate(update);
    },
    triggerPropertyViewNotification: (notification: any) => {
      NotificationService.getInstance().sendPropertyViewNotification(notification);
    }
  };
}; 